import { Component } from "react";
import { Link } from "react-router-dom";
import Rating from "../section/rating";
import SocialMedia from "../section/socialmedia";

const postTitle = "Top jackpot games";
const newsTitle = "Our Newsletter";
const desc =
  "We are Furious 9 — a Trackmania team united by precision, teamwork, and the pursuit of perfect runs. Every race is a challenge, every track is an opportunity, and every second counts.";
const newsdesc = "Join our newsletter to stay updated.";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsName: "",
      newsEmail: "",
    };
  }

  render() {
    return (
      <footer className="footer-section">


        {/* MIDDLE */}
        <div
          className="footer-middle padding-top padding-bottom"
          style={{ backgroundImage: "url(/assets/images/footer/01.jpg)" }}
        >
          <div className="container">
            <div className="row padding-lg-top">
              {/* LEFT CONTENT */}
              <div className="col-lg-4 col-md-6 col-12">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item mb-lg-0">
                    <div className="fm-item-title mb-4">
                      <img
                        src="assets/images/logo/f9-logo.png"
                        alt="logo"
                      />
                    </div>
                    <div className="fm-item-content">
                      <p className="mb-4">{desc}</p>
                      <ul className="match-social-list d-flex flex-wrap align-items-center">
                        
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* NEWSLETTER – PUSHED TO RIGHT */}
              <div className="col-lg-4 col-md-6 col-12 ms-auto text-end">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item-3 mb-lg-0">
                    <div className="fm-item-title">
                      <h4>{newsTitle}</h4>
                    </div>
                    <div className="fm-item-content">
                      <p>{newsdesc}</p>

                      <form>
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control"
                            value={this.state.newsName}
                            onChange={(e) =>
                              this.setState({ newsName: e.target.value })
                            }
                            placeholder="Your Name *"
                          />
                        </div>

                        <div className="form-group mb-2">
                          <input
                            type="email"
                            className="form-control"
                            value={this.state.newsEmail}
                            onChange={(e) =>
                              this.setState({ newsEmail: e.target.value })
                            }
                            placeholder="Your Email *"
                          />
                        </div>

                        <button type="submit" className="default-button">
                          <span>
                            Send Message{" "}
                            <i className="icofont-circled-right"></i>
                          </span>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* END NEWSLETTER */}
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bottom-content text-center">
                  <p>
                    Copyright © 2025{" "}
                    <Link to="/">Furious 9</Link> – Trackmania Esports
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
